(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-exclusions/assets/javascripts/player-exclusions.js') >= 0) return;  svs.modules.push('/components/accountservices/player-exclusions/assets/javascripts/player-exclusions.js'); 
'use strict';

var logger = svs.core.log.getLogger('accountservices: player-exclusions');
var pauseTypes = svs.accountservices.player_exclusions.utils.pauseTypes;
var gcsLevel = svs.accountservices.player_exclusions.definitions.gcsLevel;
var _svs$accountservices$ = svs.accountservices.player_exclusions.activeExlucions,
    getExclusions = _svs$accountservices$.get,
    setExclusions = _svs$accountservices$.set,
    resetExclusions = _svs$accountservices$.reset;
var gamingPauseDialog;

var confirmPauseSeen = function confirmPauseSeen(_ref) {
  var gcsLevel = _ref.gcsLevel,
      exclusion = _ref.exclusion,
      callback = _ref.callback;
  svs.core.jupiter.call({
    data: {
      gcsLevel: gcsLevel,
      gcsProduct: exclusion.gcsVertical
    },
    method: 'PUT',
    path: '/compliance/1/customerconfirmedgcsinfo'
  }, callback, function (err) {
    logger.error('Unable confirm user has seen gcs info with /compliance/1/customerconfirmedgcsinfo', err);
    callback();
  });
};

var showPauseDialog = function showPauseDialog(_ref2) {
  var title = _ref2.title,
      text = _ref2.text,
      actions = _ref2.actions,
      _ref2$icon = _ref2.icon,
      icon = _ref2$icon === void 0 ? 'self-test' : _ref2$icon;
  gamingPauseDialog = new svs.components.dialog.Confirm({
    actions: actions,
    allowDimmerClick: svs.core.detect.formfactor.mobile(),
    area: svs.components.dialog.area.POPUP,
    branding: svs.components.dialog.branding.SPORT,
    icon: icon,
    message: [{
      align: svs.components.dialog.message.align.CENTER,
      text: text,
      type: svs.components.dialog.message.TEXT
    }],
    title: title,
    type: svs.components.dialog.type.DEFAULT
  });
  svs.components.dialog.api.add(gamingPauseDialog);
};

function asyncCallback(cb) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  setTimeout(function () {
    return cb.apply(void 0, args);
  }, 10);
}

var getActions = function getActions(successFn) {
  var before = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (cb) {
    return cb();
  };
  return {
    closeButton: {
      callback: function callback() {
        return before(function () {
          gamingPauseDialog.close();
          successFn(false);
        });
      },
      title: 'STÄNG'
    },
    okButton: {
      callback: function callback() {
        return before(function () {
          gamingPauseDialog.close();
          successFn(false);
        });
      },
      title: 'OK'
    },
    toGamingResponsiblity: {
      callback: function callback() {
        return before(function () {
          svs.utils.url.navigate(svs.utils.urlMapping.get('gamingResponsibilityHome'));
        });
      },
      title: 'TILL SPELKOLL'
    },
    toGamingTest: {
      callback: function callback() {
        return before(function () {
          svs.utils.url.navigate(svs.utils.urlMapping.get('mygamingSelfTestDirect'));
        });
      },
      title: 'TILL SJÄLVTEST'
    }
  };
};

var handlePause = {
  gcsStep2: function gcsStep2(exclusion, callback) {
    var actions = getActions(callback, function (done) {
      return confirmPauseSeen({
        callback: done,
        exclusion: exclusion,
        gcsLevel: gcsLevel.STEP2
      });
    });
    showPauseDialog({
      actions: [actions.closeButton, actions.toGamingTest],
      text: svs.accountservices.player_exclusions.templates.gcs_step2({
        vertical: exclusion.vertical
      }),
      title: 'Gör ett självtest'
    });
  },
  gcsStep2AndNormal: function gcsStep2AndNormal(exclusion, callback) {
    var actions = getActions(callback, function (done) {
      return confirmPauseSeen({
        callback: done,
        exclusion: exclusion,
        gcsLevel: gcsLevel.STEP2
      });
    });
    var expiry = dateFns.format(new Date(exclusion.expiry), exclusion.is24HourExclusion ? 'dd/MM, yyyy HH:mm' : 'dd/MM, yyyy');
    showPauseDialog({
      actions: [actions.closeButton, actions.toGamingTest],
      text: svs.accountservices.player_exclusions.templates.gcs_step2_and_normal({
        expiry: expiry
      }),
      title: 'Tillfällig spelpaus'
    });
  },
  gcsStep2AndStep4: function gcsStep2AndStep4(exclusion, callback) {
    var actions = getActions(callback, function (done) {
      return confirmPauseSeen({
        callback: function callback() {
          return confirmPauseSeen({
            callback: done,
            exclusion: exclusion,
            gcsLevel: gcsLevel.STEP4
          });
        },
        exclusion: exclusion,
        gcsLevel: gcsLevel.STEP2
      });
    });
    var expiry = dateFns.format(new Date(exclusion.expiry), exclusion.is24HourExclusion ? 'dd/MM, yyyy HH:mm' : 'dd/MM, yyyy');
    showPauseDialog({
      actions: [actions.closeButton, actions.toGamingTest],
      text: svs.accountservices.player_exclusions.templates.gcs_step2_and_step4({
        expiry: expiry,
        vertical: exclusion.vertical
      }),
      title: 'Tillfällig spelpaus'
    });
  },
  gcsStep4: function gcsStep4(exclusion, callback) {
    var actions = getActions(callback, function (done) {
      return confirmPauseSeen({
        callback: done,
        exclusion: exclusion,
        gcsLevel: gcsLevel.STEP4
      });
    });
    var expiry = dateFns.format(new Date(exclusion.expiry), 'dd/MM, yyyy HH:mm');
    showPauseDialog({
      actions: [actions.closeButton, actions.toGamingResponsiblity],
      icon: 'spelpaus',
      text: svs.accountservices.player_exclusions.templates.gcs_step4({
        expiry: expiry,
        vertical: exclusion.vertical
      }),
      title: 'Tillfällig spelpaus'
    });
  },
  narPause: function narPause(callback) {
    var actions = getActions(callback);
    showPauseDialog({
      actions: [actions.closeButton],
      icon: 'spelpaus',
      text: svs.accountservices.player_exclusions.templates.nar_pause({
        noTitle: true
      }),
      title: 'Du får inte spela!'
    });
  },
  normalPause: function normalPause(exclusion, callback) {
    var actions = getActions(callback);
    var expiry = dateFns.format(new Date(exclusion.expiry), exclusion.is24HourExclusion ? 'dd/MM, yyyy HH:mm' : 'dd/MM, yyyy');
    showPauseDialog({
      actions: [actions.closeButton],
      icon: 'spelpaus',
      text: svs.accountservices.player_exclusions.templates.active_pause({
        expiry: expiry,
        isExpired: exclusion.isExpired,
        noTitle: true,
        vertical: exclusion.vertical
      }),
      title: exclusion.isExpired ? 'Spelpaus fortfarande aktiverad!' : 'Spelpaus Aktiverad!'
    });
  }
};

var canPlayOnVertical = function canPlayOnVertical(vertical) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    if (!svs.accountservices.player_exclusions.utils.isValidSubSystem(vertical)) {
      vertical = 'alla';
    }

    getExclusions(function (activeExclusions) {
      var pause = activeExclusions[vertical];

      if (activeExclusions.isBlocked) {
        handlePause.narPause(callback);
      } else if (activeExclusions.hasPause && activeExclusions.hasTotalPause || pause) {
        if (!pause) {
          pause = activeExclusions.alla;
        }

        if (pause && pause.needSelfTest) {
          if (pause.type === pauseTypes.PauseTwentyFourHoursGcs) {
            handlePause.gcsStep2AndStep4(pause, callback);
          } else if (pause.expiry || activeExclusions.alla) {
            handlePause.gcsStep2AndNormal(pause, callback);
          } else {
            handlePause.gcsStep2(pause, callback);
          }
        } else if (pause && pause.type === pauseTypes.PauseTwentyFourHoursGcs) {
          handlePause.gcsStep4(pause, callback);
        } else {
          handlePause.normalPause(pause, callback);
        }
      } else {
        asyncCallback(callback, true);
      }
    });
  } else {
    asyncCallback(callback, true);
  }
};


var hasExclusionOnVertical = function hasExclusionOnVertical(subSystem) {
  var successFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    if (svs.core.session && svs.core.session.data && svs.core.session.data.userSession && svs.core.session.data.userSession.isBlocked) {
      successFn({
        exclusionInfo: svs.accountservices.player_exclusions.templates.nar_pause(),
        hasExclusions: true
      });
    } else {
      if (subSystem) {
        subSystem = subSystem.toLowerCase();
      } else {
        successFn({
          hasPause: false
        });
        return;
      }

      getExclusions(function (activeExclusions) {
        var activePause;
        var useTotalPause = activeExclusions.hasTotalPause;
        var verticalPause = activeExclusions[subSystem];

        if (activeExclusions.alla && verticalPause) {
          if (dateFns.isAfter(new Date(activeExclusions.alla.expiry), new Date(verticalPause.expiry))) {
            activePause = activeExclusions.alla;
          } else {
            activePause = verticalPause;
            useTotalPause = false;
          }
        } else {
          activePause = activeExclusions.alla || verticalPause;
        }

        if (activePause) {
          var vertical = subSystem;

          if (useTotalPause) {
            vertical = 'alla spel';
          } else if (subSystem === 'sport') {
            vertical = 'sportspel';
          }

          var expiry = dateFns.format(new Date(activePause.expiry), activePause.is24HourExclusion ? 'dd/MM, yyyy HH:mm' : 'dd/MM, yyyy');
          successFn({
            exclusionInfo: svs.accountservices.player_exclusions.templates.active_pause({
              expiry: expiry,
              isExpired: dateFns.isAfter(new Date(), new Date(activePause.expiry)),
              vertical: vertical
            }),
            expiry: activePause.expiry,
            hasExclusions: true,
            vertical: vertical
          });
        } else {
          successFn({
            hasExclusions: false
          });
        }
      });
    }
  } else {
    successFn(false);
  }
};

svs.accountservices.player_exclusions.hasExclusionOnVertical = hasExclusionOnVertical;
svs.accountservices.player_exclusions.canPlayOnVertical = canPlayOnVertical;
svs.accountservices.player_exclusions.getActiveExlusions = getExclusions;
svs.accountservices.player_exclusions.saveExclusions = setExclusions;
svs.accountservices.player_exclusions.clearCache = resetExclusions;
 })(window);